import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Legenda',{attrs:{"titulo":"Atualizar carrinho","legenda":"Atualizar a quantidade e preço desse produto no carrinho de compras"}},[_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.atualizarItem}},[_c(VIcon,[_vm._v("\n      mdi-cart-arrow-right\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }